<script>
import { orderBy } from 'lodash'
import TimesheetCandidateCard from './timesheet-candidate-card.vue'
export default {
  name: 'TimeSheetWeekGroup',
  components: { TimesheetCandidateCard },
  props: {
    group: {
      type: Object,
      required: true,
    },
  },
  computed: {
    orderedCandidates() {
      return orderBy(this.group.timesheets, (item) => item[0].candidateFullName)
    },
  },
  methods: {
    timesheetsUpdated(selectedTimesheets) {
      this.$emit('timesheetsUpdated', selectedTimesheets)
    },
    changeTime(timesheetData) {
      this.$emit('changeTime', timesheetData)
    },
    isFirstIndex(index) {
      return index === 0
    },
    cancelBookingSubmitted(payload) {
      this.$emit('cancelBookingSubmitted', payload)
    },
  },
}
</script>

<template>
  <div class="mb-12">
    <div
      v-for="(candidateTimesheets, index) of orderedCandidates"
      :key="`timesheet-candidate-card_${group.title}_${index}`"
      class="mb-4"
    >
      <h1 v-if="isFirstIndex(index)" class="subtitle-2 mb-4">
        <v-icon left>mdi-calendar</v-icon> {{ group.title }}
      </h1>

      <TimesheetCandidateCard
        :candidate-time-sheets="candidateTimesheets"
        @timesheetsUpdated="timesheetsUpdated"
        @changeTime="changeTime"
        @cancelBookingSubmitted="cancelBookingSubmitted"
      />
    </div>
  </div>
</template>
